import { render } from "./MbBt.vue?vue&type=template&id=78410776&scoped=true"
import script from "./MbBt.vue?vue&type=script&lang=js"
export * from "./MbBt.vue?vue&type=script&lang=js"

import "./MbBt.vue?vue&type=style&index=0&id=78410776&scoped=true&lang=css"

import exportComponent from "D:\\도연희\\vuestudy\\vue-geoje\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78410776"]])

export default __exports__